import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson four.png";
import imageTwo from "../../../assets/lesson four jane.png";

function LessonFour() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>3.1</span> What are these people doing? Use these verbs to
            complete the sentences:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li className="strike">eat</li>
              <li>have</li>
              <li>lie</li>
              <li>play</li>
              <li>sit</li>
              <li>wait</li>
            </ul>
            <img src={imageOne} />
            <ol className="">
              <li>
                <input
                  className="border"
                  value="She's eating"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />{" "}
                an aple.
              </li>
              <li>
                He
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background:
                      q1.trim() === "is waiting"
                        ? "#198754"
                        : q1.trim() === "'s waiting"
                        ? "#198754"
                        : "white",
                    color:
                      q1.trim() === "is waiting"
                        ? "white"
                        : q1.trim() === "'s waiting"
                        ? "white"
                        : "black",
                  }}
                />
                for a bus.
              </li>
              <li>
                They
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "are playing"
                        ? "#198754"
                        : q2.trim() === "'re playing"
                        ? "#198754"
                        : "white",
                    color:
                      q2.trim() === "are playing"
                        ? "white"
                        : q2.trim() === "'re playing"
                        ? "white"
                        : "black",
                  }}
                />
                football.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background:
                      q3.trim() === "He's laying"
                        ? "#198754"
                        : q3.trim() === "He is laying"
                        ? "#198754"
                        : "white",
                    color:
                      q3.trim() === "He's laying"
                        ? "white"
                        : q3.trim() === "He is laying"
                        ? "white"
                        : "black",
                  }}
                />
                on the floor.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "They are having"
                        ? "#198754"
                        : q4.trim() === "They're having"
                        ? "#198754"
                        : "white",
                    color:
                      q4.trim() === "They are having"
                        ? "white"
                        : q4.trim() === "They're having"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                breakfast.
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "She is sitting"
                        ? "#198754"
                        : q5.trim() === "She's sitting"
                        ? "#198754"
                        : "white",
                    color:
                      q5.trim() === "She is sitting"
                        ? "white"
                        : q5.trim() === "She's sitting"
                        ? "white"
                        : "black",
                  }}
                />{" "}
                on the table.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>3.2</span> Complete the sentences. Use these verbs:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li>eat</li>
              <li>build</li>
              <li>cook</li>
              <li>go</li>
              <li>have</li>
              <li>stand</li>
              <li>stay</li>
              <li className="strike">work</li>
            </ul>
            <ol className="border">
              <li>
                Please be quiet. I
                <input
                  className="border"
                  value="'m working"
                  disabled
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                .
              </li>
              <li>
                'Where's John?' 'He's in the kitchen. He
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "is cooking"
                        ? "#198754"
                        : q7.trim() === "'s cooking"
                        ? "#198754"
                        : "white",
                    color:
                      q7.trim() === "is cooking"
                        ? "white"
                        : q7.trim() === "'s cooking"
                        ? "white"
                        : "black",
                  }}
                />
                .'
              </li>
              <li>
                'You
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "are standing"
                        ? "#198754"
                        : q8.trim() === "'re standing"
                        ? "#198754"
                        : "white",
                    color:
                      q8.trim() === "are standing"
                        ? "white"
                        : q8.trim() === "'re standing"
                        ? "white"
                        : "black",
                  }}
                />
                on my foot.' 'Oh, I'm sorry.'
              </li>
              <li>
                Look! Somebody
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "is swimming"
                        ? "#198754"
                        : q9.trim() === "'s swimming"
                        ? "#198754"
                        : "white",
                    color:
                      q9.trim() === "is swimming"
                        ? "white"
                        : q9.trim() === "'s swimming"
                        ? "white"
                        : "black",
                  }}
                />
                in the river.
              </li>
              <li>
                We're here on holiday. We
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "are staying"
                        ? "#198754"
                        : q10.trim() === "'re staying"
                        ? "#198754"
                        : "white",
                    color:
                      q10.trim() === "are staying"
                        ? "white"
                        : q10.trim() === "'re staying"
                        ? "white"
                        : "black",
                  }}
                />
                at the Central Hotel.
              </li>
              <li>
                'Where's Sue?' 'She
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "is having"
                        ? "#198754"
                        : q11.trim() === "'s having"
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "is having"
                        ? "white"
                        : q11.trim() === "'s having"
                        ? "white"
                        : "black",
                  }}
                />
                a shower.'
              </li>
              <li>
                They
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background:
                      q12.trim() === "are building"
                        ? "#198754"
                        : q12.trim() === "'re building"
                        ? "#198754"
                        : "white",
                    color:
                      q12.trim() === "are building"
                        ? "white"
                        : q12.trim() === "'re building"
                        ? "white"
                        : "black",
                  }}
                />
                a new hotel in the city centre at the moment.
              </li>
              <li>
                I
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background:
                      q13.trim() === "am going"
                        ? "#198754"
                        : q13.trim() === "'m going"
                        ? "#198754"
                        : "white",
                    color:
                      q13.trim() === "am going"
                        ? "white"
                        : q13.trim() === "'m going"
                        ? "white"
                        : "black",
                  }}
                />
                now. Goodbye.
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>3.3</span> Look at the picture. Write sentences about Jane.
            Use <strong>She's -ing</strong>or<strong>She isn't -ing</strong>
          </h4>
          <p className="table row">
            <img
              src={imageTwo}
              className=" col-xsm-12 col-sm-12 col-md-6 col-lg-5 col-xlg-5"
            />

            <ol className="border col-xsm-12 col-sm-12 col-md-6 col-lg-6 col-xlg-6">
              <li>
                (have dinner)
                <input
                  className="border"
                  value="Jane isn't having dinner."
                  disabled
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                (watch TV)
                <input
                  className="border"
                  value="She's watching TV."
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
              </li>
              <li>
                (sit on the floor) She
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background:
                      q16.trim() === "is sitting on the floor."
                        ? "#198754"
                        : q16.trim() === "'s sitting on the floor."
                        ? "#198754"
                        : "white",
                    color:
                      q16.trim() === "is sitting on the floor."
                        ? "white"
                        : q16.trim() === "'s sitting on the floor."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (read a book)
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background:
                      q17.trim() === "She is not reading a book."
                        ? "#198754"
                        : q17.trim() === "She isn't reading a book."
                        ? "#198754"
                        : q17.trim() === "She's not reading a book."
                        ? "#198754"
                        : "white",
                    color:
                      q17.trim() === "She is not reading a book."
                        ? "white"
                        : q17.trim() === "She isn't reading a book."
                        ? "white"
                        : q17.trim() === "She's not reading a book."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (playing the piano)
                <input
                  className="border"
                  onChange={(e) => setQ18(e.target.value)}
                  style={{
                    background:
                      q18.trim() === "She is not playing the piano."
                        ? "#198754"
                        : q18.trim() === "She isn't playing the piano."
                        ? "#198754"
                        : q18.trim() === "She's not playing the piano."
                        ? "#198754"
                        : "white",
                    color:
                      q18.trim() === "She is not playing the piano."
                        ? "white"
                        : q18.trim() === "She isn't playing the piano."
                        ? "white"
                        : q18.trim() === "She's not playing the piano."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (laugh)
                <input
                  className="border"
                  onChange={(e) => setQ19(e.target.value)}
                  style={{
                    background:
                      q19.trim() === "She is laughing."
                        ? "#198754"
                        : q19.trim() === "She's laughing."
                        ? "#198754"
                        : "white",
                    color:
                      q19.trim() === "She is laughing."
                        ? "white"
                        : q19.trim() === "She's laughing."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (wear a hat)
                <input
                  className="border"
                  onChange={(e) => setQ20(e.target.value)}
                  style={{
                    background:
                      q20.trim() === "She is wearing a hat."
                        ? "#198754"
                        : q20.trim() === "She's wearing a hat."
                        ? "#198754"
                        : "white",
                    color:
                      q20.trim() === "She is wearing a hat."
                        ? "white"
                        : q20.trim() === "She's wearing a hat."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (drink coffee)
                <input
                  className="border"
                  onChange={(e) => setQ21(e.target.value)}
                  style={{
                    background:
                      q21.trim() === "She is not drinking coffee."
                        ? "#198754"
                        : q21.trim() === "She isn't drinking coffee."
                        ? "#198754"
                        : q21.trim() === "She's not drinking coffee."
                        ? "#198754"
                        : "white",
                    color:
                      q21.trim() === "She is not drinking coffee."
                        ? "white"
                        : q21.trim() === "She isn't drinking coffee."
                        ? "white"
                        : q21.trim() === "She's not drinking coffee."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>3.4</span> What's happening now? Write true senteces.
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                (I / wash / my hair)
                <input
                  className="border"
                  value="I'm not washing my hair."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Are you thirsty?
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  value="It's snowing."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                or
                <input
                  className="border"
                  onChange={(e) => setQ22(e.target.value)}
                  value="It isn't snowing."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                (I / sit / on a chair)
                <input
                  className="border"
                  onChange={(e) => setQ23(e.target.value)}
                  style={{
                    background:
                      q23.trim() === "I am sitting on a chair."
                        ? "#198754"
                        : q23.trim() === "I'm sitting on a chair."
                        ? "#198754"
                        : q23.trim() === "I am not sitting on a chair."
                        ? "#198754"
                        : q23.trim() === "I'm not sitting on a chair."
                        ? "#198754"
                        : "white",
                    color:
                      q23.trim() === "I am sitting on a chair."
                        ? "white"
                        : q23.trim() === "I'm sitting on a chair."
                        ? "white"
                        : q23.trim() === "I am not sitting on a chair."
                        ? "white"
                        : q23.trim() === "I'm not sitting on a chair."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (I / eat)
                <input
                  className="border"
                  onChange={(e) => setQ24(e.target.value)}
                  style={{
                    background:
                      q24.trim() === "I am eating."
                        ? "#198754"
                        : q24.trim() === "I'm eating."
                        ? "#198754"
                        : q24.trim() === "I am not eating."
                        ? "#198754"
                        : q24.trim() === "I'm not eating."
                        ? "#198754"
                        : "white",
                    color:
                      q24.trim() === "I am eating."
                        ? "white"
                        : q24.trim() === "I'm eating."
                        ? "white"
                        : q24.trim() === "I am not eating."
                        ? "white"
                        : q24.trim() === "I'm not eating."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (it / rain)
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background:
                      q25.trim() === "It is raining."
                        ? "#198754"
                        : q25.trim() === "It's raining."
                        ? "#198754"
                        : q25.trim() === "It is not raining."
                        ? "#198754"
                        : q25.trim() === "It's not raining."
                        ? "#198754"
                        : "white",
                    color:
                      q25.trim() === "It is raining."
                        ? "white"
                        : q25.trim() === "It's raining."
                        ? "white"
                        : q25.trim() === "It is not raining."
                        ? "white"
                        : q25.trim() === "It's not raining."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (I / learn / English)
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "I am learning English."
                        ? "#198754"
                        : q26.trim() === "I'm learning English."
                        ? "#198754"
                        : q26.trim() === "I am not learning English."
                        ? "#198754"
                        : q26.trim() === "I'm not learning English."
                        ? "#198754"
                        : "white",
                    color:
                      q26.trim() === "I am learning English."
                        ? "white"
                        : q26.trim() === "I'm learning English."
                        ? "white"
                        : q26.trim() === "I am not learning English."
                        ? "white"
                        : q26.trim() === "I'm not learning English."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (I / listen / to music)
                <input
                  className="border"
                  onChange={(e) => setQ27(e.target.value)}
                  style={{
                    background:
                      q27.trim() === "I am listening to music."
                        ? "#198754"
                        : q27.trim() === "I'm listening to music."
                        ? "#198754"
                        : q27.trim() === "I am not listening to music."
                        ? "#198754"
                        : q27.trim() === "I'm not listening to music."
                        ? "#198754"
                        : "white",
                    color:
                      q27.trim() === "I am listening to music."
                        ? "white"
                        : q27.trim() === "I'm listening to music."
                        ? "white"
                        : q27.trim() === "I am not listening to music."
                        ? "white"
                        : q27.trim() === "I'm not listening to music."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (the sun / shine)
                <input
                  className="border"
                  onChange={(e) => setQ28(e.target.value)}
                  style={{
                    background:
                      q28.trim() === "The sun is shinning."
                        ? "#198754"
                        : q28.trim() === "The sun's shinning."
                        ? "#198754"
                        : q28.trim() === "The sun is not shinning."
                        ? "#198754"
                        : q28.trim() === "The sun isn't shinning."
                        ? "#198754"
                        : "white",
                    color:
                      q28.trim() === "The sun is shinning."
                        ? "white"
                        : q28.trim() === "The sun's shinning."
                        ? "white"
                        : q28.trim() === "The sun is not shinning."
                        ? "white"
                        : q28.trim() === "The sun isn't shinning."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (I / wear / shoes)
                <input
                  className="border"
                  onChange={(e) => setQ29(e.target.value)}
                  style={{
                    background:
                      q29.trim() === "I am wearing shoes."
                        ? "#198754"
                        : q29.trim() === "I'm wearing shoes."
                        ? "#198754"
                        : q29.trim() === "I am not wearing shoes."
                        ? "#198754"
                        : q29.trim() === "I'm not wearing shoes."
                        ? "#198754"
                        : "white",
                    color:
                      q29.trim() === "I am wearing shoes."
                        ? "white"
                        : q29.trim() === "I'm wearing shoes."
                        ? "white"
                        : q29.trim() === "I am not wearing shoes."
                        ? "white"
                        : q29.trim() === "I'm not wearing shoes."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                (I / read / a newspaper)
                <input
                  className="border"
                  onChange={(e) => setQ30(e.target.value)}
                  style={{
                    background:
                      q30.trim() === "I am reading a newspaper."
                        ? "#198754"
                        : q30.trim() === "I'm reading a newspaper."
                        ? "#198754"
                        : q30.trim() === "I am not reading a newspaper."
                        ? "#198754"
                        : q30.trim() === "I'm not reading a newspaper."
                        ? "#198754"
                        : "white",
                    color:
                      q30.trim() === "I am reading a newspaper."
                        ? "white"
                        : q30.trim() === "I'm reading a newspaper."
                        ? "white"
                        : q30.trim() === "I am not reading a newspaper."
                        ? "white"
                        : q30.trim() === "I'm not reading a newspaper."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>

        {/* <hr /> */}

        {/* <div className="task-five mb-3">
          <h4>
            <span>2.5</span> Complete the questions. Use
            <span>
              (<strong>What... / Who... / Where / How... .</strong> etc.)
            </span>
            .
          </h4>
          <p className="table row">
            <ol className="border col-xsm-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7">
              <li>
                <input
                  className="border"
                  value="How are"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                your parents?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ32(e.target.value)}
                  style={{
                    background:
                      q32.trim() === "Where is"
                        ? "#198754"
                        : q32.trim() === "Where's"
                        ? "#198754"
                        : "white",
                    color:
                      q32.trim() === "Where is"
                        ? "white"
                        : q32.trim() === "Where's"
                        ? "#198754"
                        : "black",
                  }}
                />{" "}
                the bus stop?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ33(e.target.value)}
                  style={{
                    background:
                      q33.trim() === "How old are" ? "#198754" : "white",
                    color: q33.trim() === "How old are" ? "white" : "black",
                  }}
                />{" "}
                your children?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ34(e.target.value)}
                  style={{
                    background:
                      q34.trim() === "How much are" ? "#198754" : "white",
                    color: q34.trim() === "How much are" ? "white" : "black",
                  }}
                />{" "}
                these oranges?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ35(e.target.value)}
                  style={{
                    background: q35.trim() === "What is" ? "#198754" : "white",
                    color: q35.trim() === "What is" ? "white" : "black",
                  }}
                />{" "}
                your favourite sport?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ36(e.target.value)}
                  style={{
                    background:
                      q36.trim() === "Who is"
                        ? "#198754"
                        : q36.trim() === "Who's"
                        ? "#198754"
                        : "white",
                    color:
                      q36.trim() === "Who is"
                        ? "white"
                        : q36.trim() === "Who's"
                        ? "white"
                        : "black",
                  }}
                />
                the man in the photo?
              </li>
              <li>
                <input
                  className="border"
                  onChange={(e) => setQ37(e.target.value)}
                  style={{
                    background:
                      q37.trim() === "What color are"
                        ? "#198754"
                        : q37.trim() === "What colour are"
                        ? "#198754"
                        : "white",
                    color:
                      q37.trim() === "What color are"
                        ? "white"
                        : q37.trim() === "What colour are"
                        ? "white"
                        : "black",
                  }}
                />
                your new shoes?
              </li>
            </ol>
            <ul className="border col-xsm-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3">
              <li>They're very well.</li>
              <li>At the end of the street.</li>
              <li>Five, six and ten.</li>
              <li>$1.50 a kilo.</li>
              <li>Skiing.</li>
              <li>That's my father.</li>
              <li>Black.</li>
            </ul>
          </p>
        </div> */}
      </div>
    </>
  );
}

export default LessonFour;
